import {
  GeneralPermissions,
  SettingsPermissions,
} from "@redotech/account-common/permissions";
import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { TeamType } from "@redotech/account-common/team-type";
import { MarketingFlagKey } from "@redotech/feature-flags-keys-marketing/keys";
import { OmsFlagKey } from "@redotech/feature-flags-keys-oms/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import ActivityHeartIcon from "@redotech/redo-icons/activity-heart.svg";
import ActivityHeartFilledIcon from "@redotech/redo-icons/activity-heart_filled.svg";
import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import AlertTriangleFilledIcon from "@redotech/redo-icons/alert-triangle_filled.svg";
import Announcement02Icon from "@redotech/redo-icons/announcement-02.svg";
import Announcement02FilledIcon from "@redotech/redo-icons/announcement-02_filled.svg";
import Award01Icon from "@redotech/redo-icons/award-01.svg";
import Award01FilledIcon from "@redotech/redo-icons/award-01_filled.svg";
import BarChart01Icon from "@redotech/redo-icons/bar-chart-01.svg";
import BarChart01FilledIcon from "@redotech/redo-icons/bar-chart-01_filled.svg";
import BeakerIcon from "@redotech/redo-icons/beaker-02.svg";
import BeakerFilledIcon from "@redotech/redo-icons/beaker-02_filled.svg";
import Bell03Icon from "@redotech/redo-icons/bell-03.svg";
import Bell03FilledIcon from "@redotech/redo-icons/bell-03_filled.svg";
import Brush01Icon from "@redotech/redo-icons/brush-01.svg";
import Brush01FilledIcon from "@redotech/redo-icons/brush-01_filled.svg";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import Coins01Icon from "@redotech/redo-icons/coins-01.svg";
import Coins01FilledIcon from "@redotech/redo-icons/coins-01_filled.svg";
import CoinsStacked03Icon from "@redotech/redo-icons/coins-stacked-03.svg";
import CoinsStacked03FilledIcon from "@redotech/redo-icons/coins-stacked-03_filled.svg";
import CreditCard01Icon from "@redotech/redo-icons/credit-card-01.svg";
import CreditCard01FilledIcon from "@redotech/redo-icons/credit-card-01_filled.svg";
import Cursor01Icon from "@redotech/redo-icons/cursor-01.svg";
import Cursor01FilledIcon from "@redotech/redo-icons/cursor-01_filled.svg";
import DashboardIcon from "@redotech/redo-icons/dashboard.svg";
import DashboardFilledIcon from "@redotech/redo-icons/dashboard_filled.svg";
import DatabaseIcon from "@redotech/redo-icons/database-02.svg";
import DatabaseFilledIcon from "@redotech/redo-icons/database-02_filled.svg";
import FileCheck02Icon from "@redotech/redo-icons/file-check-02.svg";
import FileCheck02FilledIcon from "@redotech/redo-icons/file-check-02_filled.svg";
import FilterLinesIcon from "@redotech/redo-icons/filter-lines.svg";
import FilterLinesFilledIcon from "@redotech/redo-icons/filter-lines_filled.svg";
import FlipBackwardIcon from "@redotech/redo-icons/flip-backward.svg";
import FlipBackwardFilledIcon from "@redotech/redo-icons/flip-backward_filled.svg";
import Globe02Icon from "@redotech/redo-icons/globe-02.svg";
import Globe02FilledIcon from "@redotech/redo-icons/globe-02_filled.svg";
import Home02Icon from "@redotech/redo-icons/home-02.svg";
import Home02FilledIcon from "@redotech/redo-icons/home-02_filled.svg";
import Inbox01Icon from "@redotech/redo-icons/inbox-01.svg";
import Inbox01FilledIcon from "@redotech/redo-icons/inbox-01_filled.svg";
import Key01Icon from "@redotech/redo-icons/key-01.svg";
import Key01FilledIcon from "@redotech/redo-icons/key-01_filled.svg";
import LayersThree02Icon from "@redotech/redo-icons/layers-three-02.svg";
import LayersThree02FilledIcon from "@redotech/redo-icons/layers-three-02_filled.svg";
import LayoutGrid01Icon from "@redotech/redo-icons/layout-grid-01.svg";
import LayoutGrid01FilledIcon from "@redotech/redo-icons/layout-grid-01_filled.svg";
import Lock01Icon from "@redotech/redo-icons/lock-01.svg";
import Lock01FilledIcon from "@redotech/redo-icons/lock-01_filled.svg";
import Mail01Icon from "@redotech/redo-icons/mail-01.svg";
import Mail01FilledIcon from "@redotech/redo-icons/mail-01_filled.svg";
import Map01Icon from "@redotech/redo-icons/map-01.svg";
import Map01FilledIcon from "@redotech/redo-icons/map-01_filled.svg";
import MessageChatCircleIcon from "@redotech/redo-icons/message-chat-circle.svg";
import MessageChatCircleFilledIcon from "@redotech/redo-icons/message-chat-circle_filled.svg";
import MessageSquare01Icon from "@redotech/redo-icons/message-square-01.svg";
import MessageSquare01FilledIcon from "@redotech/redo-icons/message-square-01_filled.svg";
import Monitor01Icon from "@redotech/redo-icons/monitor-01.svg";
import Monitor01FilledIcon from "@redotech/redo-icons/monitor-01_filled.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import PackageFilledIcon from "@redotech/redo-icons/package_filled.svg";
import Pencil01Icon from "@redotech/redo-icons/pencil-01.svg";
import Pencil01FilledIcon from "@redotech/redo-icons/pencil-01_filled.svg";
import Phone01Icon from "@redotech/redo-icons/phone-01.svg";
import Phone01FilledIcon from "@redotech/redo-icons/phone-01_filled.svg";
import RefreshCw01Icon from "@redotech/redo-icons/refresh-cw-01.svg";
import RefreshCw01FilledIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import Route01Icon from "@redotech/redo-icons/route.svg";
import Route01FilledIcon from "@redotech/redo-icons/route_filled.svg";
import Settings02Icon from "@redotech/redo-icons/settings-02.svg";
import Settings02FilledIcon from "@redotech/redo-icons/settings-02_filled.svg";
import Share07Icon from "@redotech/redo-icons/share-07.svg";
import Share07FilledIcon from "@redotech/redo-icons/share-07_filled.svg";
import ShieldDollarIcon from "@redotech/redo-icons/shield-dollar.svg";
import ShieldDollarFilledIcon from "@redotech/redo-icons/shield-dollar_filled.svg";
import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import ShieldTickFilledIcon from "@redotech/redo-icons/shield-tick_filled.svg";
import ShoppingBag01Icon from "@redotech/redo-icons/shopping-bag-01.svg";
import ShoppingBag01FilledIcon from "@redotech/redo-icons/shopping-bag-01_filled.svg";
import ShoppingCart01Icon from "@redotech/redo-icons/shopping-cart-01.svg";
import ShoppingCart01FilledIcon from "@redotech/redo-icons/shopping-cart-01_filled.svg";
import ShoppingCart03Icon from "@redotech/redo-icons/shopping-cart-03.svg";
import ShoppingCart03FilledIcon from "@redotech/redo-icons/shopping-cart-03_filled.svg";
import Stars01Icon from "@redotech/redo-icons/stars-01.svg";
import Stars01FilledIcon from "@redotech/redo-icons/stars-01_filled.svg";
import Tag01Icon from "@redotech/redo-icons/tag-01.svg";
import Tag01FilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import Target01Icon from "@redotech/redo-icons/target-01.svg";
import Target01FilledIcon from "@redotech/redo-icons/target-01_filled.svg";
import Tool01Icon from "@redotech/redo-icons/tool-01.svg";
import Tool01FilledIcon from "@redotech/redo-icons/tool-01_filled.svg";
import Truck01Icon from "@redotech/redo-icons/truck-01.svg";
import Truck01FilledIcon from "@redotech/redo-icons/truck-01_filled.svg";
import UserCircleIcon from "@redotech/redo-icons/user-circle.svg";
import UserCircleFilledIcon from "@redotech/redo-icons/user-circle_filled.svg";
import UserEditIcon from "@redotech/redo-icons/user-edit.svg";
import UserEditFilledIcon from "@redotech/redo-icons/user-edit_filled.svg";
import Users01Icon from "@redotech/redo-icons/users-01.svg";
import Users01FilledIcon from "@redotech/redo-icons/users-01_filled.svg";
import UsersPlusIcon from "@redotech/redo-icons/users-plus.svg";
import UsersPlusFilledIcon from "@redotech/redo-icons/users-plus_filled.svg";
import WarehouseIcon from "@redotech/redo-icons/warehouse.svg";
import WarehouseFilledIcon from "@redotech/redo-icons/warehouse_filled.svg";
import XCircleIcon from "@redotech/redo-icons/x-circle.svg";
import XCircleFilledIcon from "@redotech/redo-icons/x-circle_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import ZapFilledIcon from "@redotech/redo-icons/zap_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useReturnsNewSettings } from "@redotech/redo-merchant-app-common/settings/returns-new-settings-context";
import { useReturnsSettingsExperience } from "@redotech/redo-merchant-app-common/settings/use-returns-settings-experience";
import { useShippingNewSettings } from "@redotech/redo-merchant-app-common/shipping-new-settings-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useIsRedoSuppliesTeam } from "@redotech/redo-merchant-app-common/use-is-redo-supplies-team";
import { useTeamFeatureFlag } from "@redotech/redo-merchant-app-common/use-team-feature-flag";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import {
  NotificationTab,
  notificationTabToFriendly,
} from "@redotech/redo-merchant-general-app/setting/notification/notification-tabs";
import { RegistrationRewardType } from "@redotech/redo-return-warranties-common/extended-warranty";
import {
  RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH,
  RETURNS_AUTOMATIONS_SETTINGS_PATH,
  RETURNS_CONSOLIDATED_SETTINGS_PATH,
} from "@redotech/redo-settings-common/flat-team-settings/returns/settings-paths";
import { isShopifyEmail } from "@redotech/redo-shopify-common/shopify-email";
import {
  SettingItem,
  SettingItemSearchTab,
  SettingsSection,
  SettingsSectionEnum,
} from "@redotech/redo-web/arbiter-components/navigation/redo-settings-nav";
import { filterTruthy } from "@redotech/util/array";
import { useContext } from "react";
import { INTEGRATIONS_HUB_PERMISSIONS } from "../../../integrations/catalog/catalog-data";
import { ConversionSuiteStatusesContext } from "../../../redo-suite/conversion-cloud";
import { MarketingCloudStatusesContext } from "../../../redo-suite/marketing-cloud";
import { OrderManagementSuiteStatusesContext } from "../../../redo-suite/order-management-cloud";
import { SupportSuiteStatusesContext } from "../../../redo-suite/support-cloud";
import {
  GeneralAiTab,
  generalAiTabToFriendly,
} from "../../../setting/ai-agent/general-tabs";
import {
  CustomerWidgetTab,
  customerWidgetTabToFriendly,
} from "../../../setting/customer-widget/customer-widget-tabs";
import { useReturnsSettingsTabs } from "../../../setting/returns/returns-settings-tabs";
import { ReturnsSettingsCallout } from "./returns-settings-callout";
import { addSettingsCatalogSearchTerms } from "./settings-navigation-search";
import {
  useFulfillmentSettings as useNewFulfillmentSettings,
  useShippingSettings as useNewShippingSettings,
  withNewGeneralSearchTerms,
} from "./settings.new";

export function useSettingsItems(): SettingsSection[] | null {
  const enabled = useShippingNewSettings();
  const returnsNewSettings = useReturnsNewSettings();
  const routes = useRequiredContext(MerchantRoutesContext);
  const originalGeneralSettings = useGeneralSettings();
  const generalSettings = enabled
    ? withNewGeneralSearchTerms(originalGeneralSettings)
    : originalGeneralSettings;
  const personalSettings = usePersonalSettings();
  const aiSettings = useAiSettings();
  // const catalogSettings = useCatalogSettings();
  const conversionSettings = useConversionSettings();
  const paymentsSettings = usePaymentsSettings();
  const chargebacksSettings = useChargebacksSettings();
  const customersSettings = useCustomersSettings();
  const inventoryManagementSettings = useInventoryManagementSettings();
  const marketingSettings = useMarketingSettings();
  const orderTrackingSettings = useOrderTrackingSettings();
  const productsSettings = useProductsSettings();
  const returnsSettings = useReturnsSettings();
  const warrantiesSettings = useWarrantiesSettings();
  const originalFulfillmentSettings = useFulfillmentSettings();
  const newFulfillmentSettings = useNewFulfillmentSettings();
  const fulfillmentSettings = enabled
    ? newFulfillmentSettings
    : originalFulfillmentSettings;
  const originalShippingSettings = useShippingSettings();
  const newShippingSettings = useNewShippingSettings();
  const shippingSettings = enabled
    ? newShippingSettings
    : originalShippingSettings;
  const internationalSettings = useInternationalSettings();
  const supportSettings = useSupportSettings();
  const suppliesSettings = useSuppliesSettings();

  const allSettingsItems: SettingsSection[] = filterTruthy([
    generalSettings,
    aiSettings,
    // catalogSettings,
    conversionSettings,
    paymentsSettings,
    chargebacksSettings,
    customersSettings,
    fulfillmentSettings,
    inventoryManagementSettings,
    ...(enabled ? [suppliesSettings] : []),
    marketingSettings,
    orderTrackingSettings,
    personalSettings,
    productsSettings,
    returnsSettings,
    shippingSettings,
    internationalSettings,
    supportSettings,
    ...(!enabled ? [suppliesSettings] : []),
    warrantiesSettings,
  ]);

  return addSettingsCatalogSearchTerms({
    shippingNewSettings: enabled,
    returnsNewSettings,
    routes,
    sections: allSettingsItems,
    viewerVisibility: "merchant",
  });
}

function useAiSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );

  if (!canManageAiSettings) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "ai-general",
      href: routes.getSettingsSubRoute("ai/general"),
      friendlyName: t("General", {
        context: "merchant settings label for general AI configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
      searchTabs: Object.values(GeneralAiTab).map((tab) => ({
        id: tab,
        label: generalAiTabToFriendly(tab),
      })),
    },
    {
      id: "ai-knowledge",
      href: routes.getSettingsSubRoute("ai/knowledge"),
      friendlyName: t("Knowledge", {
        context: "merchant settings label for AI knowledge sources",
      }),
      UnfilledIcon: Stars01Icon,
      FilledIcon: Stars01FilledIcon,
    },
    {
      id: "ai-skills",
      href: routes.getSettingsSubRoute("ai/skills"),
      friendlyName: t("Skills", {
        context: "merchant settings label for AI agent skills",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.AI, items };
}

function useChargebacksSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  if (!team.settings.disputes?.enabled) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "chargebacks",
      href: routes.getSettingsSubRoute("chargebacks"),
      friendlyName: t("Chargebacks", {
        context: "merchant settings label for chargebacks configuration",
      }),
      UnfilledIcon: ShieldDollarIcon,
      FilledIcon: ShieldDollarFilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.CHARGEBACKS, items };
}

function useConversionSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { checkoutOptimizationEnabled } = useRequiredContext(
    ConversionSuiteStatusesContext,
  );

  const canManageCheckoutOptimizationSettings = useHasPermission(
    SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
  );

  const items: SettingItem[] = filterTruthy([
    checkoutOptimizationEnabled &&
      canManageCheckoutOptimizationSettings && {
        id: "general",
        href: routes.getSettingsSubRoute("conversion/general"),
        friendlyName: t("Conversion", {
          context:
            "merchant settings label for checkout conversion configuration",
        }),
        UnfilledIcon: ShoppingCart03Icon,
        FilledIcon: ShoppingCart03FilledIcon,
      },
  ]);

  // Only show the section if at least one page is accessible
  if (items.length === 0) {
    return undefined;
  }

  items.sort((a, b) => {
    // sort by friendlyName but make sure "General" is at the top
    if (a.id === "general") {
      return -1;
    }

    if (b.id === "general") {
      return 1;
    }

    return a.friendlyName.localeCompare(b.friendlyName);
  });

  return { name: SettingsSectionEnum.CONVERSION, items };
}

function usePaymentsSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const canManageCheckoutOptimizationSettings = useHasPermission(
    SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
  );
  const hsaEnabled = !!team.settings.hsa?.enabled;
  if (!hsaEnabled || !canManageCheckoutOptimizationSettings) {
    return undefined;
  }
  const items: SettingItem[] = [
    {
      id: "hsa",
      href: routes.getSettingsSubRoute("payments/hsa"),
      friendlyName: t("HSA/FSA"),
      UnfilledIcon: ActivityHeartIcon,
      FilledIcon: ActivityHeartFilledIcon,
    },
  ];
  return { name: SettingsSectionEnum.PAYMENTS, items };
}

function useCustomersSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  // Note: customerAccounts is not part of our centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;
  const canManageCustomersSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );

  if (!customerAccountsEnabled || !canManageCustomersSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "customer-accounts-ad-blocks",
      href: routes.getSettingsSubRoute("customer-accounts-ad-blocks"),
      friendlyName: t("Ad blocks", {
        context: "merchant settings label for customer account advertisements",
      }),
      UnfilledIcon: Target01Icon,
      FilledIcon: Target01FilledIcon,
    },
    {
      id: "customer-accounts-storefront-display",
      href: routes.getSettingsSubRoute("customer-accounts-storefront-display"),
      friendlyName: t("Storefront display", {
        context:
          "merchant settings label for customer account storefront displays",
      }),
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.CUSTOMER_ACCOUNTS, items };
}

// Redo-internal: configures what Redo charges merchants for supplies, so it
// is hidden from every team but Redo's own supplies team.
function useSuppliesSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const isSuppliesTeam = useIsRedoSuppliesTeam();
  const canManageOther = useHasPermission(GeneralPermissions.OTHER);

  if (!isSuppliesTeam || !canManageOther) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "supplies-shipping-rules",
      href: routes.getSettingsSubRoute("supplies/shipping-rules"),
      friendlyName: t("Shipping rules", {
        context: "merchant settings label for supplies shipping rules",
      }),
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.SUPPLIES, items };
}

function useInventoryManagementSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const imsEnabled = team.settings.ims?.enabled;
  const newSettings = useShippingNewSettings();
  const { enabled: imsQuickbooksEnabled } = useTeamFeatureFlag(
    OmsFlagKey.IMS_QUICKBOOKS,
    { forceEnabledForRedoUsers: false },
  );

  const canManageOther = useHasPermission(GeneralPermissions.OTHER);

  if (!imsEnabled || !canManageOther) {
    return undefined;
  }

  if (newSettings) {
    return {
      name: SettingsSectionEnum.INVENTORY_MANAGEMENT,
      items: [
        {
          id: "inventory-management",
          href: routes.getSettingsSubRoute("inventory-management"),
          friendlyName: t("Inventory management"),
          searchTerms: [
            "general",
            "purchase orders",
            "accounting",
            "QuickBooks",
          ],
          UnfilledIcon: PackageIcon,
          FilledIcon: PackageFilledIcon,
        },
      ],
    };
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "inventory-general",
      href: routes.getSettingsSubRoute("inventory-management/general"),
      friendlyName: t("General", {
        context: "merchant settings label for general inventory configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    {
      id: "inventory-purchase-orders",
      href: routes.getSettingsSubRoute("inventory-management/purchase-orders"),
      friendlyName: t("Purchase orders", {
        context: "merchant settings label for inventory purchase orders",
      }),
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    imsQuickbooksEnabled && {
      id: "inventory-accounting",
      href: routes.getSettingsSubRoute("inventory-management/quickbooks"),
      friendlyName: t("Accounting", {
        context: "merchant settings label for inventory accounting",
      }),
      UnfilledIcon: CreditCard01Icon,
      FilledIcon: CreditCard01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.INVENTORY_MANAGEMENT, items };
}

function useFulfillmentSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const canManageFulfillmentSettings = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );

  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  if (
    !(omsEnabled && canManageFulfillmentSettings) &&
    !canManageAdminGeneralSettings
  ) {
    return undefined;
  }

  const omsFulfill = omsEnabled && canManageFulfillmentSettings;

  const items: SettingItem[] = filterTruthy([
    omsFulfill && {
      id: "general-oms",
      href: routes.getSettingsSubRoute("oms/general"),
      friendlyName: t("General", {
        context:
          "merchant settings label for general order fulfillment configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    omsFulfill && {
      id: "automerge-link",
      href: routes.getSettingsSubRoute("oms/automerge-shipments"),
      friendlyName: t("Auto-merge fulfillments", {
        context:
          "merchant settings label for automatically merging fulfillments",
      }),
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    omsFulfill && {
      id: "automations-oms",
      href: routes.getSettingsSubRoute("oms/automations"),
      friendlyName: t("Automations", {
        context: "merchant settings label for order fulfillment automations",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    omsFulfill && {
      id: "custom-import-schemas",
      href: routes.getSettingsSubRoute("oms/custom-import-schemas"),
      friendlyName: t("Custom imports", {
        context: "merchant settings label for custom order import schemas",
      }),
      UnfilledIcon: DatabaseIcon,
      FilledIcon: DatabaseFilledIcon,
    },
    omsFulfill && {
      id: "international",
      href: routes.getSettingsSubRoute("oms/international"),
      friendlyName: t("International", {
        context: "merchant settings label for international order fulfillment",
      }),
      UnfilledIcon: Globe02Icon,
      FilledIcon: Globe02FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "order-editing-button",
      href: routes.getSettingsSubRoute("order-management/order-editing"),
      friendlyName: t("Order editing", {
        context: "merchant settings label for order editing",
      }),
      UnfilledIcon: Tool01Icon,
      FilledIcon: Tool01FilledIcon,
    },
    omsFulfill && {
      id: "parcels-link",
      href: routes.getSettingsSubRoute("oms/packages"),
      friendlyName: t("Packages", {
        context: "merchant settings label for fulfillment packages",
      }),
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    omsFulfill && {
      id: "presets-link",
      href: routes.getSettingsSubRoute("oms/presets"),
      friendlyName: t("Presets", {
        context: "merchant settings label for order fulfillment presets",
      }),
      UnfilledIcon: LayersThree02Icon,
      FilledIcon: LayersThree02FilledIcon,
    },
    omsFulfill && {
      id: "printing",
      href: routes.getSettingsSubRoute("oms/printing"),
      friendlyName: t("Printing", {
        context: "merchant settings label for order fulfillment printing",
      }),
      UnfilledIcon: FileCheck02Icon,
      FilledIcon: FileCheck02FilledIcon,
    },
    omsFulfill && {
      id: "reports",
      href: routes.getSettingsSubRoute("oms/reports"),
      friendlyName: t("Reports", {
        context: "merchant settings label for order fulfillment reports",
      }),
      UnfilledIcon: BarChart01Icon,
      FilledIcon: BarChart01FilledIcon,
    },
    omsFulfill && {
      id: "scanning-warehouse",
      href: routes.getSettingsSubRoute("oms/scanning-warehouse"),
      friendlyName: t("Scanning & warehouse", {
        context:
          "merchant settings label for fulfillment scanning and warehouse tools",
      }),
      UnfilledIcon: DatabaseIcon,
      FilledIcon: DatabaseFilledIcon,
    },
    omsFulfill && {
      id: "warehouse-dashboard",
      href: routes.getSettingsSubRoute("oms/warehouse-dashboard"),
      friendlyName: t("Warehouse dashboard", {
        context:
          "merchant settings label for the fulfillment warehouse dashboard",
      }),
      UnfilledIcon: DashboardIcon,
      FilledIcon: DashboardFilledIcon,
    },
    omsFulfill && {
      id: "security",
      href: routes.getSettingsSubRoute("oms/security"),
      friendlyName: t("Security", {
        context: "merchant settings label for fulfillment security",
      }),
      UnfilledIcon: Lock01Icon,
      FilledIcon: Lock01FilledIcon,
    },
    omsFulfill && {
      id: "warehouse-layouts",
      href: routes.getSettingsSubRoute("oms/warehouse-layouts"),
      friendlyName: t("Warehouse layouts", {
        context: "merchant settings label for fulfillment warehouse layouts",
      }),
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
    omsFulfill && {
      id: "work-order-flows",
      href: routes.getSettingsSubRoute("oms/work-order-flows"),
      friendlyName: t("Work order flows", {
        context: "merchant settings label for fulfillment work order flows",
      }),
      UnfilledIcon: Route01Icon,
      FilledIcon: Route01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.ORDER_FULFILLMENT, items };
}

function usePersonalSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  const items: SettingItem[] = [
    {
      id: "personal-profile",
      href: routes.getSettingsSubRoute("personal"),
      friendlyName: t("Profile", {
        context: "merchant settings label for the current user's profile",
      }),
      UnfilledIcon: UserEditIcon,
      FilledIcon: UserEditFilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.PERSONAL, items };
}

function useGeneralSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { supportEnabled } = useRequiredContext(SupportSuiteStatusesContext);
  // Note: Some settings not in centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const aiEnabled = team.settings.support?.ai?.enabled;
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;

  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );
  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  const canManageSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );
  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );
  const canManageCustomerAccountsSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );
  // Mirrors the /settings/integrations route's any-of permission gate.
  const canAccessIntegrations = useHasPermission(
    ...INTEGRATIONS_HUB_PERMISSIONS,
  );

  const canManageTeamRoles = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_ROLES,
  );

  const canManageChatWidget =
    canManageSupportSettings ||
    canManageAiSettings ||
    canManageCustomerAccountsSettings ||
    canManageAdminGeneralSettings;
  const chatWidgetEnabled =
    supportEnabled || aiEnabled || customerAccountsEnabled;
  // Show customer widget in General only when support is NOT enabled
  const showChatWidgetInGeneral =
    !supportEnabled && chatWidgetEnabled && canManageChatWidget;

  const canManageDeveloperSettings = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_DEVELOPMENT,
  );

  const canManageTeamUsers = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_USERS,
  );

  const returnsExperience = useReturnsSettingsExperience();
  const customerPortalReplaced =
    (returnsExperience.pending || returnsExperience.useNewUi) &&
    canManageReturnsSettings;

  const canViewBilling = useHasPermission(SettingsPermissions.VIEW_BILLING);
  const canManageBillingSettings = useHasPermission(
    SettingsPermissions.SET_BILLING_SETTINGS,
  );

  const items: SettingItem[] = filterTruthy([
    !isShopifyEmail(team.email) &&
      (canManageAdminGeneralSettings ||
        canViewBilling ||
        canManageBillingSettings) && {
        id: "billing-button",
        href: routes.getSettingsSubRoute("billing"),
        friendlyName: t("Billing", {
          context: "merchant settings label for billing",
        }),
        UnfilledIcon: CreditCard01Icon,
        FilledIcon: CreditCard01FilledIcon,
        children: [
          {
            id: "billing-home-button",
            href: routes.getSettingsSubRoute("billing"),
            friendlyName: t("Home", {
              context: "merchant settings label for the billing overview",
            }),
            UnfilledIcon: Home02Icon,
            FilledIcon: Home02FilledIcon,
          },
          {
            id: "billing-activity-button",
            href: routes.getSettingsSubRoute("billing/reports"),
            friendlyName: t("Activity", {
              context: "merchant settings label for billing activity",
            }),
            UnfilledIcon: BarChart01Icon,
            FilledIcon: BarChart01FilledIcon,
          },
          {
            id: "bills-button",
            href: routes.getSettingsSubRoute("billing/bills"),
            friendlyName: t("Bills", {
              context: "merchant settings label for merchant bills",
            }),
            UnfilledIcon: CreditCard01Icon,
            FilledIcon: CreditCard01FilledIcon,
          },
        ],
      },
    canManageAdminGeneralSettings && {
      id: "brand-kit-button",
      href: routes.getSettingsSubRoute("brand-kit"),
      friendlyName: t("Brand kit", {
        context: "merchant settings label for brand assets and styling",
      }),
      UnfilledIcon: Brush01Icon,
      FilledIcon: Brush01FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "communication-button",
      href: routes.getSettingsSubRoute("communication"),
      friendlyName: t("Communication", {
        context: "merchant settings label for customer communication",
      }),
      UnfilledIcon: Mail01Icon,
      FilledIcon: Mail01FilledIcon,
    },
    (canManageAdminGeneralSettings || canManageReturnsSettings) &&
      !customerPortalReplaced && {
        id: "customer-portal-button",
        href: routes.getSettingsSubRoute("customer-portal"),
        friendlyName: t("Customer portal", {
          context: "merchant settings label for the customer returns portal",
        }),
        UnfilledIcon: UserCircleIcon,
        FilledIcon: UserCircleFilledIcon,
        children: filterTruthy([
          {
            id: "portal-builder",
            href: routes.getSettingsSubRoute("portal-builder"),
            friendlyName: t("Portal builder", {
              context:
                "merchant settings label for the customer portal builder",
            }),
            UnfilledIcon: Cursor01Icon,
            FilledIcon: Cursor01FilledIcon,
          },
          canManageReturnsSettings &&
            team.platform === "shopify" && {
              id: "point-of-sale",
              href: routes.getSettingsSubRoute("pos"),
              friendlyName: t("Point of sale", {
                context: "merchant settings label for point-of-sale returns",
              }),
              UnfilledIcon: ShoppingCart01Icon,
              FilledIcon: ShoppingCart01FilledIcon,
            },
          canManageReturnsSettings &&
            canManageTeamRoles && {
              id: "permissions",
              href: routes.getSettingsSubRoute("permissions"),
              friendlyName: t("Merchant-created returns", {
                context:
                  "merchant settings label for merchant-created return permissions",
              }),
              UnfilledIcon: Key01Icon,
              FilledIcon: Key01FilledIcon,
            },
        ]),
      },
    showChatWidgetInGeneral && {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: t("Customer widget", {
        context: "merchant settings label for the customer widget",
      }),
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
      searchTabs: getCustomerWidgetSearchTabs(),
    },
    canManageDeveloperSettings && {
      id: "developer-button",
      href: routes.getSettingsSubRoute("developer"),
      friendlyName: t("Developer", {
        context: "merchant settings label for developer tools",
      }),
      UnfilledIcon: CodeBrowserIcon,
      FilledIcon: CodeBrowserFilledIcon,
    },
    canAccessIntegrations && {
      id: "general-integrations",
      href: routes.getSettingsSubRoute("integrations"),
      friendlyName: t("Integrations", {
        context: "merchant settings label for the integrations catalog",
      }),
      UnfilledIcon: Share07Icon,
      FilledIcon: Share07FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "notifications-button",
      href: routes.getSettingsSubRoute("notifications"),
      friendlyName: t("Notifications", {
        context: "merchant settings label for team notifications",
      }),
      UnfilledIcon: Bell03Icon,
      FilledIcon: Bell03FilledIcon,
      searchTabs: Object.values(NotificationTab).map((tab) => ({
        id: tab,
        label: notificationTabToFriendly(tab),
      })),
    },
    canManageTeamRoles && {
      id: "roles-button",
      href: routes.getSettingsSubRoute("roles"),
      friendlyName: t("Roles", {
        context: "merchant settings label for team roles",
      }),
      UnfilledIcon: ShieldTickIcon,
      FilledIcon: ShieldTickFilledIcon,
    },
    canManageTeamUsers && {
      id: "users-button",
      href: routes.getSettingsSubRoute("users"),
      friendlyName: t("Users", {
        context: "merchant settings label for team users",
      }),
      UnfilledIcon: Users01Icon,
      FilledIcon: Users01FilledIcon,
    },
    canManageTeamUsers && {
      id: "user-groups-button",
      href: routes.getSettingsSubRoute("user-groups"),
      friendlyName: t("Groups", {
        context: "merchant settings label for team groups",
      }),
      UnfilledIcon: UsersPlusIcon,
      FilledIcon: UsersPlusFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.GENERAL, items };
}

function useMarketingSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { returnTrackingEnabled, emailSmsEnabled, orderTrackingEnabled } =
    useRequiredContext(MarketingCloudStatusesContext);
  const canManageMarketingSettings = useHasPermission(
    SettingsPermissions.SET_MARKETING_SETTINGS,
  );
  const { enabled: attributionEnabled } = useTeamFeatureFlag(
    MarketingFlagKey.MARKETING_ATTRIBUTION_METRICS_CLICKHOUSE,
    { forceEnabledForRedoUsers: false },
  );
  if (
    (!returnTrackingEnabled && !emailSmsEnabled && !orderTrackingEnabled) ||
    !canManageMarketingSettings
  ) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "audience",
      href: routes.getSettingsSubRoute("audience"),
      friendlyName: t("Audience", {
        context: "merchant settings label for marketing audiences",
      }),
      UnfilledIcon: Users01Icon,
      FilledIcon: Users01FilledIcon,
    },
    {
      id: "email-domain",
      href: routes.getSettingsSubRoute("email-domain"),
      friendlyName: t("Email domain", {
        context: "merchant settings label for the marketing email domain",
      }),
      UnfilledIcon: Mail01Icon,
      FilledIcon: Mail01FilledIcon,
    },
    {
      id: "offer-page-configuration",
      href: routes.getSettingsSubRoute("offer-page-configuration"),
      friendlyName: t("Offer page", {
        context: "merchant settings label for the marketing offer page",
      }),
      UnfilledIcon: CoinsStacked03Icon,
      FilledIcon: CoinsStacked03FilledIcon,
    },
    {
      id: "marketing-sms",
      href: routes.getSettingsSubRoute("sms-marketing"),
      friendlyName: t("SMS", {
        context: "merchant settings label for SMS marketing",
      }),
      UnfilledIcon: Phone01Icon,
      FilledIcon: Phone01FilledIcon,
    },
    {
      id: "subscribe-keywords",
      href: routes.getSettingsSubRoute("subscribe-keywords"),
      friendlyName: t("Keywords", {
        context: "merchant settings label for SMS subscription keywords",
      }),
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    },
    {
      id: "recover-settings",
      href: routes.getSettingsSubRoute("recover-settings"),
      friendlyName: "Recover",
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    // These settings only change what the ClickHouse attribution reports, so
    // they are shown to the teams reading it.
    ...(attributionEnabled
      ? [
          {
            id: "attribution",
            href: routes.getSettingsSubRoute("attribution"),
            friendlyName: t("Attribution", {
              context: "merchant settings label for marketing attribution",
            }),
            UnfilledIcon: BarChart01Icon,
            FilledIcon: BarChart01FilledIcon,
          },
        ]
      : []),
    {
      id: "marketing-agent",
      href: routes.getSettingsSubRoute("marketing-agent"),
      friendlyName: t("{{productName}}", {
        productName: "Marketing Agent",
        context:
          "merchant settings label containing the official Marketing Agent product name",
      }),
      UnfilledIcon: Stars01Icon,
      FilledIcon: Stars01Icon,
    },
  ];

  return { name: SettingsSectionEnum.MARKETING, items };
}

function useOrderTrackingSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { orderTrackingEnabled } = useRequiredContext(
    MarketingCloudStatusesContext,
  );
  const canManageMarketingSettings = useHasPermission(
    SettingsPermissions.SET_MARKETING_SETTINGS,
  );

  if (!orderTrackingEnabled || !canManageMarketingSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "order-tracking-general",
      href: routes.getSettingsSubRoute("order-tracking"),
      friendlyName: t("General", {
        context:
          "merchant settings label for general order tracking configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.ORDER_TRACKING, items };
}

function useProductsSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const user = useContext(UserContext);
  const canManageProductsSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  if (!canManageProductsSettings) {
    return;
  }

  const isRedoEmployee = isRedoEmailAddress(user?.email);

  const items: SettingItem[] = filterTruthy([
    isRedoEmployee && {
      id: "attributes-button",
      href: routes.getSettingsSubRoute("attributes"),
      friendlyName: t("Attributes", {
        context: "merchant settings label for product attribute definitions",
      }),
      UnfilledIcon: LayersThree02Icon,
      FilledIcon: LayersThree02FilledIcon,
    },
    {
      id: "products-button",
      href: routes.getSettingsSubRoute("products"),
      friendlyName: t("Products", {
        context: "merchant settings label for products",
      }),
      UnfilledIcon: ShoppingBag01Icon,
      FilledIcon: ShoppingBag01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.PRODUCTS, items };
}

function useReturnsSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const user = useContext(UserContext);
  const returnsExperience = useReturnsSettingsExperience();
  const returnsSettingsTabs = useReturnsSettingsTabs();

  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  if (!canManageReturnsSettings) {
    return undefined;
  }

  const is3PL = team.teamType === TeamType.FulfillmentService;
  const wmsSotAnywhere =
    team.settings?.outboundLabels?.wms?.sourceOfTruthEnabled === true;
  const showWmsReturnsSettings = is3PL || wmsSotAnywhere;
  const showLegacyPages =
    !returnsExperience.pending && !returnsExperience.useNewUi;
  const returnsSettingsHref = routes.getSettingsSubRoute(
    RETURNS_CONSOLIDATED_SETTINGS_PATH,
  );

  const items: SettingItem[] = filterTruthy([
    returnsExperience.useNewUi && {
      id: "returns-consolidated",
      href: returnsSettingsHref,
      friendlyName: t("Returns"),
      UnfilledIcon: FlipBackwardIcon,
      FilledIcon: FlipBackwardFilledIcon,
      searchTabs: returnsSettingsTabs.map(({ key, label }) => ({
        id: key,
        label,
      })),
      renderAnchor: (row) => (
        <ReturnsSettingsCallout href={returnsSettingsHref}>
          {row}
        </ReturnsSettingsCallout>
      ),
    },
    isRedoEmailAddress(user?.email) && {
      id: "ab-tests",
      href: routes.getSettingsSubRoute("ab-tests"),
      friendlyName: t("A/B tests"),
      UnfilledIcon: BeakerIcon,
      FilledIcon: BeakerFilledIcon,
    },
    {
      id: "assessments",
      href: routes.getSettingsSubRoute("assessments"),
      friendlyName: t("Assessments", {
        context: "merchant settings label for return assessments",
      }),
      UnfilledIcon: FileCheck02Icon,
      FilledIcon: FileCheck02FilledIcon,
    },
    showLegacyPages && {
      id: "automations-button",
      href: routes.getSettingsSubRoute(RETURNS_AUTOMATIONS_SETTINGS_PATH),
      friendlyName: t("Automations", {
        context: "merchant settings label for return automations",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    showLegacyPages && {
      id: "coverage-button",
      href: routes.getSettingsSubRoute("coverage"),
      friendlyName: t("Coverage", {
        context: "merchant settings label for return coverage",
      }),
      UnfilledIcon: ShieldTickIcon,
      FilledIcon: ShieldTickFilledIcon,
    },
    showLegacyPages && {
      id: "exchanges-button",
      href: routes.getSettingsSubRoute("exchanges"),
      friendlyName: t("Exchanges", {
        context: "merchant settings label for return exchanges",
      }),
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    showLegacyPages && {
      id: "return-processing-button",
      href: routes.getSettingsSubRoute(
        RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH,
      ),
      friendlyName: t("Processing", {
        context: "merchant settings label for return processing flows",
      }),
      UnfilledIcon: FilterLinesIcon,
      FilledIcon: FilterLinesFilledIcon,
    },
    showLegacyPages && {
      id: "processing-button",
      href: routes.getSettingsSubRoute("processing"),
      friendlyName: t("Refunds & store credit", {
        context: "merchant settings label for return refunds and store credit",
      }),
      UnfilledIcon: Coins01Icon,
      FilledIcon: Coins01FilledIcon,
    },
    is3PL && {
      id: "processing-groups",
      href: routes.getSettingsSubRoute("processing-groups"),
      friendlyName: t("Processing groups", {
        context: "merchant settings label for return processing groups",
      }),
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
    showWmsReturnsSettings && {
      id: "post-processing",
      href: routes.getSettingsSubRoute("post-processing"),
      friendlyName: t("Post processing", {
        context: "merchant settings label for post-return processing",
      }),
      UnfilledIcon: Route01Icon,
      FilledIcon: Route01FilledIcon,
    },
    is3PL && {
      id: "consolidation",
      href: routes.getSettingsSubRoute("consolidation"),
      friendlyName: t("Consolidation", {
        context: "merchant settings label for return consolidation",
      }),
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    showLegacyPages && {
      id: "shipping-button",
      href: routes.getSettingsSubRoute("shipping"),
      friendlyName: t("Shipping", {
        context: "merchant settings label for return shipping",
      }),
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    },
    showLegacyPages && {
      id: "returns-ui",
      href: routes.getSettingsSubRoute("returns-ui"),
      friendlyName: t("Return detail view", {
        context: "merchant settings label for the return detail view",
      }),
      UnfilledIcon: Monitor01Icon,
      FilledIcon: Monitor01FilledIcon,
    },
    showLegacyPages && {
      id: "warehouse-button",
      href: routes.getSettingsSubRoute("warehouse"),
      friendlyName: t("Warehouse", {
        context: "merchant settings label for the return warehouse",
      }),
      UnfilledIcon: WarehouseIcon,
      FilledIcon: WarehouseFilledIcon,
    },
    {
      id: "withdrawals",
      href: routes.getSettingsSubRoute("withdrawals"),
      friendlyName: t("Withdrawals", {
        context:
          "merchant settings label for customer statutory withdrawal-from-purchase requests, equivalent to the legal right of withdrawal, not cash or inventory withdrawals",
      }),
      UnfilledIcon: XCircleIcon,
      FilledIcon: XCircleFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.RETURNS_AND_CLAIMS, items };
}

function useWarrantiesSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { warrantiesEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const team = useRequiredContext(TeamContext);
  const registrationRewardsEnabled =
    team.settings.warranties?.registrationRewardType !==
    RegistrationRewardType.DISABLED;

  const canManageWarrantiesSettings = useHasPermission(
    SettingsPermissions.SET_WARRANTY_SETTINGS,
  );

  if (!warrantiesEnabled || !canManageWarrantiesSettings) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "registration-settings",
      href: routes.getSettingsSubRoute("registrations"),
      friendlyName: t("Registration", {
        context: "merchant settings label for warranty registration",
      }),
      UnfilledIcon: Pencil01Icon,
      FilledIcon: Pencil01FilledIcon,
    },
    registrationRewardsEnabled && {
      id: "warranty-registration-button",
      href: routes.getSettingsSubRoute("registration-rewards"),
      friendlyName: t("Registration rewards", {
        context: "merchant settings label for warranty registration rewards",
      }),
      UnfilledIcon: Award01Icon,
      FilledIcon: Award01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.WARRANTIES, items };
}

function useInternationalSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const marketsEnabled = !!team?.settings?.landedCost?.enabled;
  const canManageInternationalSettings = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );
  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    SettingsPermissions.SET_SHIPPING_SETTINGS,
  );

  if (!canManageInternationalSettings && !canManageReturnsSettings) {
    return undefined;
  }

  const items: SettingItem[] = [];

  if (canManageInternationalSettings && marketsEnabled) {
    items.push({
      id: "international-markets",
      href: routes.getSettingsSubRoute("international/markets"),
      friendlyName: t("Markets", {
        context: "merchant settings label for international markets",
      }),
      UnfilledIcon: Globe02Icon,
      FilledIcon: Globe02FilledIcon,
    });
    items.push({
      id: "international-restrictions",
      href: routes.getSettingsSubRoute("international/restrictions"),
      friendlyName: t("Restrictions", {
        context:
          "merchant settings label for international shipping restrictions",
      }),
      UnfilledIcon: AlertTriangleIcon,
      FilledIcon: AlertTriangleFilledIcon,
    });
  }

  if (canManageReturnsSettings) {
    items.push({
      id: "international-returns",
      href: routes.getSettingsSubRoute("international/returns"),
      friendlyName: t("International Returns", {
        context: "merchant settings label for international returns",
      }),
      UnfilledIcon: FlipBackwardIcon,
      FilledIcon: FlipBackwardFilledIcon,
    });
  }

  if (items.length === 0) {
    return undefined;
  }

  return { name: SettingsSectionEnum.INTERNATIONAL, items };
}

function useShippingSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const canManageShippingSettings = useHasPermission(
    SettingsPermissions.SET_SHIPPING_SETTINGS,
  );

  if (!canManageShippingSettings) {
    return undefined;
  }

  // cspell:disable-next-line
  // Third party TESCOM teams should not have access to shipping settings
  const hideTeams = [
    "68a50f1378bdf9a9c1352e8b",
    "68a51f39ad07ff22f074fb25",
    "68a51f7715aa9428462967c6",
    "68a52001e14afead23f253cd",
    "68a51fbf1aa2c4f5c2b6c0c3",
  ];

  const hideShippingSettings = team?._id && hideTeams.includes(team?._id);
  if (hideShippingSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "carriers-link",
      href: routes.getSettingsSubRoute("carriers"),
      friendlyName: t("Carriers", {
        context: "merchant settings label for shipping carriers",
      }),
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    },
    {
      id: "fulfillment-cutoff-link",
      href: routes.getSettingsSubRoute("fulfillment-cutoff"),
      friendlyName: t("Fulfillment promise", {
        context: "merchant settings label for the shipping fulfillment promise",
      }),
      UnfilledIcon: Announcement02Icon,
      FilledIcon: Announcement02FilledIcon,
    },
    {
      id: "freight-link",
      href: routes.getSettingsSubRoute("freight"),
      friendlyName: t("Freight", {
        context: "merchant settings label for freight shipping",
      }),
      UnfilledIcon: Map01Icon,
      FilledIcon: Map01FilledIcon,
    },
  ];

  const lcgEnabled = !!team?.settings?.landedCost?.enabled;

  if (lcgEnabled) {
    items.push({
      id: "shipping-discounts-link",
      href: routes.getSettingsSubRoute("discounts"),
      friendlyName: t("Discounts", {
        context: "merchant settings label for shipping discounts",
      }),
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    });
  }

  if (lcgEnabled && !omsEnabled) {
    items.push({
      id: "cross-border-link",
      href: routes.getSettingsSubRoute("cross-border"),
      friendlyName: t("Cross border", {
        context: "merchant settings label for cross-border shipping",
      }),
      UnfilledIcon: Globe02Icon,
      FilledIcon: Globe02FilledIcon,
    });
  }

  return { name: SettingsSectionEnum.SHIPPING, items };
}

function useSupportSettings(): SettingsSection | undefined {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const { supportEnabled } = useRequiredContext(SupportSuiteStatusesContext);
  // Note: Some settings not in centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const aiEnabled = team.settings.support?.ai?.enabled;
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;

  const canManageSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );

  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );
  const canManageCustomerAccountsSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );
  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  const canManageChatWidget =
    canManageSupportSettings ||
    canManageAiSettings ||
    canManageCustomerAccountsSettings ||
    canManageAdminGeneralSettings;
  const chatWidgetEnabled =
    supportEnabled || aiEnabled || customerAccountsEnabled;
  // Show customer widget in Support only when support IS enabled
  const showChatWidgetInSupport =
    supportEnabled && chatWidgetEnabled && canManageChatWidget;

  // Show Support when a permitted support or widget setting is available.
  if (!supportEnabled || (!canManageSupportSettings && !canManageChatWidget)) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    canManageSupportSettings && {
      id: "support-general",
      href: routes.getSettingsSubRoute("general"),
      friendlyName: t("General", {
        context:
          "merchant settings label for general customer support configuration",
      }),
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    showChatWidgetInSupport && {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: t("Customer widget", {
        context: "merchant settings label for the customer widget",
      }),
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
      searchTabs: getCustomerWidgetSearchTabs(),
    },
    canManageSupportSettings && {
      id: "support-channels",
      href: routes.getSettingsSubRoute("channels"),
      friendlyName: t("Channels", {
        context: "merchant settings label for customer support channels",
      }),
      UnfilledIcon: Inbox01Icon,
      FilledIcon: Inbox01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-tags",
      href: routes.getSettingsSubRoute(`${"tags"}`),
      friendlyName: t("Tags", {
        context: "merchant settings label for customer support tags",
      }),
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-macros",
      href: routes.getSettingsSubRoute("macros"),
      friendlyName: t("Macros", {
        context: "merchant settings label for customer support macros",
      }),
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    canManageSupportSettings && {
      id: "support-topics",
      href: routes.getSettingsSubRoute("topics"),
      friendlyName: t("Topics", {
        context: "merchant settings label for customer support topics",
      }),
      UnfilledIcon: MessageSquare01Icon,
      FilledIcon: MessageSquare01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-rules",
      href: routes.getSettingsSubRoute("rules"),
      friendlyName: t("Rules", {
        context: "merchant settings label for customer support rules",
      }),
      UnfilledIcon: FilterLinesIcon,
      FilledIcon: FilterLinesFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.SUPPORT, items };
}

function getCustomerWidgetSearchTabs(): SettingItemSearchTab[] {
  return Object.values(CustomerWidgetTab).map((tab) => ({
    id: tab,
    label: customerWidgetTabToFriendly(tab),
  }));
}
